// tslint:disable-next-line: eofline
export * from './src/app/home/home.module';
